import React from "react";
import { Typography, Box } from "@mui/material";
import { VolumeCard } from "./VolumeCard";

export const VolumesList = React.memo(
  ({
    volumes,
    onEditVolume,
    onRemoveVolume,
    onRemoveItem,
    mode = "create",
  }) => {
    if (!volumes || volumes.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {mode === "edit"
            ? "Nenhum volume. Crie um novo volume."
            : "Nenhum volume cadastrado."}
        </Typography>
      );
    }

    return (
      <Box display="flex" flexDirection="column" gap={1}>
        {volumes.map((v, idx) => (
          <VolumeCard
            key={v.identifier || `vol-${idx}`}
            v={v}
            idx={idx}
            onEditVolume={onEditVolume}
            onRemoveVolume={onRemoveVolume}
            onRemoveItem={onRemoveItem}
            mode={mode}
          />
        ))}
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.volumes === nextProps.volumes &&
      prevProps.onEditVolume === nextProps.onEditVolume &&
      prevProps.onRemoveVolume === nextProps.onRemoveVolume &&
      prevProps.onRemoveItem === nextProps.onRemoveItem &&
      prevProps.mode === nextProps.mode
    );
  },
);
